/*
	© 2016 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module Cart
define('C3.ShoppingExtensions.IncomingEquipment.Router'
,	[	

		'C3.ShoppingExtensions.IncomingEquipment.Collection'
	,       'C3.ShoppingExtensions.IncomingEquipment.View'
	,	'jQuery'
	,	'Backbone'
	,   'Utils'
	]
,	function (

		IncomingEquipmentCollection
	,       IncomingEquipmentView
	,	jQuery
	,	Backbone
	,   Utils
	)
{
	'use strict';

	// @class Cart.Router responsible to know render the cart when the user navigates to the cart url @extends Backbone.Router
	return Backbone.Router.extend({

		routes: {
			'incoming-equipment': 'getIncomingEquipment'	
		,	'incoming-equipment?:options': 'getIncomingEquipment'
		}

	,	initialize: function (application)
		{
			this.application = application;
			//this.profileModel = ProfileModel.getInstance();
		}

	,   getIncomingEquipment: function(options)
		{
			options = (options) ? Utils.parseUrlOptions(options) : {page: 1};
			options.page = options.page || 1;

			var collection = new IncomingEquipmentCollection()
			
			var ieView = new IncomingEquipmentView({
				    application: this.application
				,   collection : collection				
				,   pageNumber: options.page
				});


			collection.fetch({ data:{				
				pageNumber: options.page,
				resultsPerPage: 50,
				filters: ''
			} }).done(function() { ieView.showContent(); });
		
			
		}	
	});
});
